import { render, staticRenderFns } from "./GenerateReceiptComponent.vue?vue&type=template&id=196ea7b8&"
import script from "./GenerateReceiptComponent.vue?vue&type=script&lang=js&"
export * from "./GenerateReceiptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports